module.exports = require("inspector");


//////////////////
// WEBPACK FOOTER
// external "inspector"
// module id = 84
// module chunks = 0